<template>
  <div class="stops-info">
    <div class="stops-info__content">
      <!-- Residential Validation Message -->
      <div class="message-error">
        <span v-if="showErrorResidentialMessage"> * Please change the address </span>
      </div>
      <b-tabs card no-fade>
        <b-tab :title="selectedMode">
          <b-overlay
            :show="loading"
            rounded="sm"
            class="stops-info__overlay"
            variant="light"
            blur="10px"
          >
            <span
              v-if="!loading"
              class="go-back mb-4 ml-4 d-flex"
              @click="changeView('CarriersInfo')"
            >
              <i class="ion ion-chevron-back-outline"></i>
              <p class="ml-2">{{ $t("carriers.goBack") }}</p>
            </span>

            <div class="stops-info__load-name" v-if="!loading">
              <span> {{ $t("carriers.quoteNumber") }} {{ chosenLoad.name }} </span>
            </div>
            <div class="operation-selector-container" v-if="!loading && chosenLoad.mode_id === 'a0k1I0000005eufQAA'">
              <OperationSelector
                :selectedOperation="chosenLoad.import_export"
                :disabled="true"
              />
            </div>
            <div>
              <CarrierSelectedTendering
                v-if="chosenLoad && selectedCarrier && selectedCarrier.carrier"
                :selectedCarrier="selectedCarrier"
                :chosenLoad="chosenLoad"
                :originalCarrierArray="carriersAndTrucks && carriersAndTrucks.carriers ? carriersAndTrucks.carriers : []"
                :isDrayage="chosenLoad.mode_name.toLowerCase() === 'drayage'"
               />
            </div>
            <div class="stops-info-card">
              <div class="form-container mt-3">
                <div class="form-container__pickup" v-show="currentStep === 'pickup' && selectedCarrier">
                  <StopsShippingInfo
                    v-if="!loading"
                    @getStopData="getStopData"
                    @getReferences="getReferences"
                    v-model="stopsPickup"
                    :mode="'pickup'"
                    :locationInformation="location.pickup"
                    :contactInformation="contact.pickup"
                    :limitIntructionsCharacters="limitIntructionsCharacters"
                    :shippingInformation="shippingInfo.pickup"
                    :selectedCarrier="selectedCarrier"
                    :isDrayage="chosenLoad && chosenLoad.mode_name && chosenLoad.mode_name.toLowerCase() === 'drayage'"

                    ref="pickupStop"
                  />
                  <StopsShippingInfoSkeleton v-else />
                </div>
                <div
                  class="form-container__delivery"
                  v-show="(screenWidth && screenWidth > 800) || currentStep === 'delivery' && selectedCarrier"
                >
                  <StopsShippingInfo
                    v-if="!loading"
                    @getStopData="getStopData"
                    @getReferences="getReferences"
                    @accountInformation="accountInformation"
                    v-model="stopsDelivery"
                    :mode="'delivery'"
                    :locationInformation="location.delivery"
                    :contactInformation="contact.delivery"
                    :shippingInformation="shippingInfo.delivery"
                    :limitIntructionsCharacters="limitIntructionsCharacters"
                    :transitTime="transitTime"
                    :selectedCarrier="selectedCarrier"
                    :isDrayage="chosenLoad && chosenLoad.mode_name && chosenLoad.mode_name.toLowerCase() === 'drayage'"

                    ref="deliveryStop"
                  />
                  <StopsShippingInfoSkeleton v-else />
                </div>
              </div>
              <div v-if="screenWidth >= 800 || currentStep === 'lineItems'">
                <LoadDetail
                  @getReferences="getReferences"
                  :chosenLoad="chosenLoad"
                  :renderView="'Desktop'"
                  :persistedInformation="references.loadInformation"
                  :screenWidth="screenWidth"
                  :isDrayage="chosenLoad.mode_name.toLowerCase() === 'drayage'"
                  ref="loadDetail"
                />
              </div>
              <hr class="divider" v-if="screenWidth >= 800" />
              <LineItemsContainer
                v-if="selectedCarrier"
                :chosenLoad="chosenLoad"
                :screenWidth="screenWidth"
                :loading="loading"
                :isHazmat="isHazmat"
                :currentStep="currentStep"
                :selectedCarrier="selectedCarrier"
                ref="lineItemsContainer"
              />
              <div class="continue-button-container" v-if="chosenLoad">
                <b-overlay
                  class="continue-button-overlay"
                  :show="updatingRequestInProcess"
                  rounded="sm"
                >
                  <button
                    :class="isCreditLimit ? 'button-tender disabled-button' : 'button-tender'"
                    id="tender-button"
                    v-if="screenWidth && screenWidth >= 800"
                    @click="updateStops()"
                  >
                    {{ isCreditLimit ? $t("stopsInfo.creditLimit") : $t("stopsInfo.continue") }}
                  </button>
                  <button
                    class="button-tender"
                    v-show="
                      (currentStep === 'delivery' || currentStep === 'lineItems') &&
                      screenWidth &&
                      screenWidth < 800
                    "
                    @click="reponsiveFlowBack(currentStep === 'delivery' ? 'pickup' : 'delivery')"
                  >
                    {{ currentStep === "delivery" ? $t("stopsInfo.back") : "" }}
                    {{ currentStep === "lineItems" ? $t("stopsInfo.back") : "" }}
                  </button>
                  <button
                    :class="currentStep === 'lineItems' ? isCreditLimit ? 'button-tender disabled-button' : 'button-tender' : 'button-tender'"
                    v-show="
                      (currentStep === 'delivery' && screenWidth && screenWidth < 800) ||
                      (currentStep && screenWidth && screenWidth < 800)
                    "
                    @click="updateStopsResponsive(currentStep)"
                  >
                    {{ currentStep === "delivery" ? $t("stopsInfo.next") : "" }}
                    {{ currentStep === "pickup" ? $t("stopsInfo.next") : "" }}
                    {{ currentStep === "lineItems" ? isCreditLimit ? $t("stopsInfo.creditLimit") : $t("stopsInfo.continue") : "" }}
                  </button>
                </b-overlay>
              </div>
            </div>
            <template #overlay>
              <div class="loading" v-show="loading">
                <b-icon
                  icon="truck"
                  font-scale="3"
                  animation="cylon"
                  class="loading__text"
                ></b-icon>
                <p class="loading__text">{{ $t("loading") }}...</p>
              </div>
            </template>
          </b-overlay>
        </b-tab>
      </b-tabs>
    </div>
    <b-modal
      centered
      size="lg"
      v-model="tenderConfirmationModal"
      ref="confirmation-modal"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      @hide="handleModalClosing"
    >
      <TenderConfirmation
        v-if="chosenLoad"
        v-model="tenderConfirmationModal"
        :selectedCarrier="selectedCarrier"
        :chosenLoad="chosenLoad"
        :lineItems="chosenLoad.line_items"
        :pickupStopInfo="stopsPickup"
        :carriersAndTrucks="carriersAndTrucks"
        :isDrayage="chosenLoad.mode_name.toLowerCase() === 'drayage'"
        @changeLoadingTender="changeLoadingTender"
      />
    </b-modal>
    <b-overlay
      :show="loadingTender || creatingTender || requestInProgress"
      rounded="sm"
      z-index="1200"
      no-wrap
      fixed
    >
      <template #overlay>
        <div class="loading-overlay-tender">
          <b-icon icon="truck" animation="cylon" font-scale="4"></b-icon>
          <FadeAnimationTextArray :textArray="loadingTextArray" :duration="6000" />
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable operator-linebreak */
/* eslint-disable prefer-destructuring */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import onReSize from "@/Extend/onResize";
import StopsShippingInfo from "./components/StopInformation.vue";
import StopsShippingInfoSkeleton from "./components/StopInformationSkeleton.vue";
import TenderConfirmation from "./components/TenderConfirmation.vue";
import CarrierSelectedTendering from "./components/CarrierSelectedTendering.vue";
import LoadDetail from "./components/LoadDetail.vue";
import FadeAnimationTextArray from "../../../components/FadeAnimationTextArray.vue";
import LoadingTextArray from "../../../utils/LoadingTextArray";
import OperationSelector from "../Drayage/OperationSelector.vue";
import LineItemsContainer from "./components/lineItems/LineItemsContainer.vue";
import TenderIndexedDB from "../../../Extend/TenderIndexedDB";
import modes from "../modes";

export default {
  name: "StopsResume",
  mixins: [onReSize, TenderIndexedDB],
  components: {
    StopsShippingInfo,
    StopsShippingInfoSkeleton,
    TenderConfirmation,
    LoadDetail,
    FadeAnimationTextArray,
    LineItemsContainer,
    OperationSelector,
    CarrierSelectedTendering
  },
  data() {
    return {
      loadingTender: false,
      creatingTender: false,
      requestInProgress: false,
      tenderConfirmationModal: false,
      stopsPickup: null,
      stopsDelivery: null,
      chosenLoad: null,
      loading: false,
      description: "",
      nmfc_number: "",
      stops: null,
      shippingInfo: {
        pickup: null,
        delivery: null,
      },
      contact: {
        pickup: null,
        delivery: null,
      },
      location: {
        pickup: null,
        delivery: null,
      },
      currentStep: "pickup",
      mode: null,
      carriersAndTrucks: null,
      transitTime: null,
      hazmatError: false,
      isHazmat: false,
      indexedDBInstance: null,
      references: {
        pickup: null,
        delivery: null,
        loadInformation: null,
      },
      loadingTextArray: LoadingTextArray.tender,
      lineItemsReference: null,
      selectedCarrier: null,
      limitIntructionsCharacters: null,
      /* Residential Locations variables */
      isResidentialDeliveryAccesorialFound: false,
      showErrorResidentialMessage: false,
      deliveryfieldValidation: false,
      responseCustomerQuotes: null,
      isCreditLimit: false,
    };
  },
  watch: {
    loading() {
      if (this.loading) {
        window.onbeforeunload = () => {};
      } else {
        window.onbeforeunload = null;
      }
    },
    screenWidth() {
      if (this.screenWidth > 800) {
        this.currentStep = "pickup";
      }
    },
    selectedCarrier: {
      deep: true,
      handler() {
        if (this.selectedCarrier && this.selectedCarrier.carrier) {
          this.analizeCarrierToLimitIntructions();
        }
      },
    },
  },
  computed: {
    selectedMode() {
      // eslint-disable-next-line operator-linebreak
      const isMultiservice =
        "multiservice" in this.chosenLoad
          ? this.chosenLoad.multiservice
          : this.chosenLoad.load.multiservice;
      if (isMultiservice) {
        return "ALL OPTIONS";
      }
      return this.chosenLoad.mode_name.toUpperCase();
    },
    ...mapGetters({
      updatingRequestInProcess: "load/tender/getRequestInProcess",
    }),
  },
  async created() {
    this.loading = true;
    this.$store.commit("load/tender/setRequestInProcess", false);
    const { loadId } = this.$route.params;
    this.chosenLoad = this.$store.getters["load/getChosenLoad"];
    if (!this.chosenLoad && loadId) {
      this.chosenLoad = await this.$store.dispatch("load/getLoadById", loadId);
    }
    this.loadIsHazmat();
    this.distributeLoadInfoByStops();
    if (this.chosenLoad) {
      this.references.loadInformation = {
        billing_reference: this.chosenLoad.billing_reference || "",
        po_number: this.chosenLoad.po_number || "",
        container: this.chosenLoad.container || "",
      };
    }

    const promises = [
      this.getSalesforceAccounts(),
      this.$store.dispatch("carriers/getAllOptionsCarriers", loadId),
      this.$store.dispatch("carriersAlert/getAllCarriersAlert"),
    ];
    await Promise.all(promises).then((values) => {
      this.carriersAndTrucks = values[1];
    });
    this.getLoadCarrierSelectedInfo();
    if (!this.selectedCarrier || !this.selectedCarrier.carrier) {
      await this.getCarrierById();
    }
    await this.checkLoadIdInIndexedDB(
      "quoteBook",
      "tenderReferences",
      this.$route.params.loadId,
      this.references
    );
    this.loadIsHazmat();
    if (this.chosenLoad?.mode_name?.toLowerCase() !== 'drayage') {
      this.getTransitTime();
    }
    this.responseCustomerQuotes = await this.$store.dispatch("load/getCustomerQuotes", loadId);
    this.isCreditLimit = this.responseCustomerQuotes && this.responseCustomerQuotes.credit_hold;
    this.loading = false;
  },
  beforeDestroy() {
    this.$store.commit("load/resetGroundShipment");
  },
  methods: {
    /* Residential Locations */
    async accountInformation(data) {
      this.isResidentialDeliveryAccesorialFound = this.findAccesorialByName("Residential Delivery");
      if (
        this.selectedCarrier?.source === "easy-post" &&
        data !== null &&
        !this.isResidentialDeliveryAccesorialFound
      ) {
        if (data.account_id !== undefined || data?.id !== undefined) {
          this.verifyResidentialStopByAccount(data?.id_salesforce || data?.id);
        }
        return;
      }
      this.deliveryfieldValidation = false;
      this.showErrorResidentialMessage = false;
    },
    async verifyResidentialStopByAccount(id) {
      const response = await this.$store.dispatch("address/verifyStopByAccount", id);
      if (response.residential) {
        this.showErrorResidentialMessage = true;
        this.deliveryfieldValidation = true;
        this.swal({
          title:
            "This location is residential, therefore, in order to proceed, you must include the 'Residential' accessorial",
          icon: "warning",
          buttons: {
            requote: {
              text: "Requote with accessorial",
              value: "requote",
            },
            changeLocation: {
              text: "Change location",
              value: "changeLocation",
            },
          },
          dangerMode: false,
        }).then((value) => {
          switch (value) {
            case "requote":
              this.addResidentialDeliveryAccessorial();
              break;
            case "changeLocation":
              this.$refs.deliveryStop.cancelSelectContact(true);
              break;
            default:
              this.$refs.deliveryStop.cancelSelectContact(true);
              break;
          }
        });
      }
    },
    async addResidentialDeliveryAccessorial() {
      const idLoad = this.$route.params.loadId;
      const response = await this.$store.dispatch("load/updateResidentialAccessorial", idLoad);
      if (response.status === 200) {
        this.addDeliveryAccessorialVuex(idLoad, response.data?.id);
        this.$router.push({
          name: "CarriersInfo",
          params: {
            loadId: idLoad,
            socket: true,
          },
        });
      }
    },
    findAccesorialByName(name) {
      const getAccessorials = this.$store.getters["load/getChosenLoad"];
      return getAccessorials.accessorials.some((item) => item.name === name);
    },
    addDeliveryAccessorialVuex(idLoad, idResponse) {
      const newDeliveryAccessorial = {
        accessorial_id: 20,
        accessorial_type: "delivery",
        description: null,
        id: idResponse,
        id_load: idLoad,
        name: "Residential Delivery",
        order: null,
        related_name: null,
        tms_code: {
          accessorialId: "a011I00000325JAQAY",
          accessorialName: "Residential Delivery",
          stopNumber: null,
        },
      };
      this.$store.commit("load/modifyChosenLoadSpecificData", {
        key: "accessorials",
        value: [newDeliveryAccessorial],
      });
    },
    /* End Residential Locations */
    distributeLoadInfoByStops() {
      Object.keys(this.shippingInfo).forEach((key) => {
        const type = key === "pickup" ? "is_pickup" : "is_dropoff";
        this.shippingInfo[key] = this.chosenLoad.stops.find((element) => element[type] === true);
        if (this.shippingInfo[key].contact_info_id) {
          this.contact[key] = this.chosenLoad.contacts.find(
            (element) => element?.id === this.shippingInfo[key].contact_info_id
          );
        }
        if (this.shippingInfo[key].location_id) {
          this.location[key] = this.chosenLoad.accounts.find(
            (element) => element?.id === this.shippingInfo[key].location_id
          );
        }
      });
    },
    async getSalesforceAccounts() {
      if (this.$options.filters.checkPermission("get:salesforce-accounts")) {
        const dataSalesforceAccounts = {
          params: {
            // ONLY FOR TEST ACCOUNT
            account_id: process.env.VUE_APP_ACCOUNT_ID_TEST,
            skip: 0,
            limit: 1000,
          },
        };
        await this.$store.dispatch("load/stops/getSalesforceAccounts", dataSalesforceAccounts);
      }
    },
    changeView(routeName) {
      this.$store.commit("carriers/resetCarriersList");
      this.$router.push({
        name: routeName,
        params: {
          quoteType: "all-options",
          loadId: this.$route.params.loadId,
        },
      });
    },
    async updateStopsendpointconsumption() {
      if (this.$options.filters.checkPermission("patch:stop")) {
        this.$store.commit("load/tender/setRequestInProcess", true);
        const loadInformation = await this.$refs.loadDetail.updateLoadInformation();
        const foundHazmatItem = this.$refs.lineItemsContainer.findDefaultHazmatItem();
        const uploadStopsPromises = [foundHazmatItem];
        if (loadInformation) {
          uploadStopsPromises.push(await loadInformation);
        }
        this.chosenLoad.stops.forEach((stop) => {
          let matchedStop;
          let stopType;
          if (this.stopsPickup?.id === stop?.id) {
            matchedStop = this.stopsPickup;
            stopType = "stopsPickup";
          } else if (this.stopsDelivery?.id === stop?.id) {
            matchedStop = this.stopsDelivery;
            stopType = "stopsDelivery";
          }
          const payload = {
            load_id: this.$route.params.loadId,
            stop_id: stop?.id,
            body: {
              expected_date: dayjs(matchedStop.shippingData.date).format("YYYY-MM-DD"),
              shipping_receiving_hours: `${matchedStop.shippingData.firstHour}-${matchedStop.shippingData.secondHour}`,
              pickup_delivery_number: matchedStop.shippingData.references,
              instructions: matchedStop.shippingData.instructions,
            },
          };
          this.$store.commit("load/tender/setStopObject", {
            stopType,
            body: JSON.parse(JSON.stringify(payload.body)),
          });
          uploadStopsPromises.push(this.$store.dispatch("load/stops/updateStop", payload));
        });
        return uploadStopsPromises;
      }
    },
    async updateStopsendpointconsumptionDrayage() {
      if (this.$options.filters.checkPermission("patch:stop")) {
        this.$store.commit("load/tender/setRequestInProcess", true);
        const uploadStopsPromises = [];
        const loadInformation = await this.$refs.loadDetail.updateLoadInformation();
        if (loadInformation) {
          uploadStopsPromises.push(await loadInformation);
        }
        this.stopsPickup.shippingData.firstHour = "01:00";
        this.stopsPickup.shippingData.secondHour = "23:59";
        this.stopsPickup.shippingData.date = null;
        this.chosenLoad.stops.forEach((stop) => {
          let matchedStop;
          let stopType;
          if (this.stopsPickup?.id === stop?.id) {
            matchedStop = this.stopsPickup;
            stopType = "stopsPickup";
          } else if (this.stopsDelivery?.id === stop?.id) {
            matchedStop = this.stopsDelivery;
            stopType = "stopsDelivery";
          }
          const payload = {
            load_id: this.$route.params.loadId,
            stop_id: stop?.id,
            body: {
              shipping_receiving_hours: `${matchedStop.shippingData.firstHour}-${matchedStop.shippingData.secondHour}`,
              references: matchedStop.shippingData.references,
              instructions: matchedStop.shippingData.instructions,
              ...(matchedStop.shippingData.date &&
                dayjs(matchedStop.shippingData.date).isValid()
                ? { expected_date: dayjs(matchedStop.shippingData.date).format("YYYY-MM-DD") }
                : {}),
            },
          };
          this.$store.commit("load/tender/setStopObject", {
            stopType,
            body: JSON.parse(JSON.stringify(payload.body)),
          });
          uploadStopsPromises.push(this.$store.dispatch("load/stops/updateStop", payload));
        });
        return uploadStopsPromises;
      }
    },
    async updateStops() {
      const PO_NUMBER = this.$refs.loadDetail.getIfPOIsValid();
      if (this.chosenLoad.mode_id === 'a0k1I0000005eufQAA') { // drayage
        const fieldsValidationPickupDrayage = this.$refs.pickupStop.stopFieldsValidation();
        const fieldsValidationDeliveryDrayage = this.$refs.deliveryStop.stopFieldsValidation();
        if (fieldsValidationDeliveryDrayage && fieldsValidationPickupDrayage && PO_NUMBER) {
          this.$store.commit("load/tender/setRequestInProcess", true);
          this.openConfirmationModal();
          this.patchInsuranceInfoToLoad();
          const loadRequestsCopy = await this.updateStopsendpointconsumptionDrayage();
          await this.loadPromisesHandler([loadRequestsCopy].flat());
        }
      } else {
        const fieldsValidationPickup = this.$refs.pickupStop.stopFieldsValidation();
        const fieldsValidationDelivery = this.$refs.deliveryStop.stopFieldsValidation();
        const fieldsValidationLineItems =
          await this.$refs.lineItemsContainer.validateLineItemsReference();
        let ftlLimitsValidation = true;
        if (
          this.chosenLoad.mode_id === modes.ftl.modeId ||
          this.chosenLoad.mode_id === modes.reefer.modeId
        ) {
          ftlLimitsValidation = await this.$refs.lineItemsContainer.validateFTLLimits();
        }
        if (!ftlLimitsValidation) {
          this.creatingLoad = false;
          this.notifyWeightLimit();
        }
        /* Another validation on residency is also added. deliveryfieldValidation */
        if (
          fieldsValidationPickup &&
          fieldsValidationDelivery &&
          PO_NUMBER &&
          fieldsValidationLineItems &&
          ftlLimitsValidation &&
          !this.deliveryfieldValidation
        ) {
          this.$store.commit("load/tender/setRequestInProcess", true);
          this.openConfirmationModal();
          this.patchInsuranceInfoToLoad();
          const lineItemsRequests = await this.$refs.lineItemsContainer.updateLoadLineItems();
          const loadRequests = await this.updateStopsendpointconsumption();
          await this.loadPromisesHandler([lineItemsRequests, loadRequests].flat());
        }
      }
    },
    async loadPromisesHandler(requests) {
      await Promise.all(requests).finally(() => {
        this.$store.commit("load/tender/setRequestInProcess", false);
      });
    },
    openConfirmationModal() {
      this.tenderConfirmationModal = true;
    },
    async updateStopsResponsive(currentStep) {
      if (this.currentStep === "pickup") {
        const fieldsValidationPickup = this.$refs.pickupStop.stopFieldsValidation();
        if (!fieldsValidationPickup) {
          return;
        }
        this.currentStep = "delivery";
      } else if (this.currentStep === "delivery") {
        const fieldsValidationDelivery = this.$refs.deliveryStop.stopFieldsValidation();
        if (!fieldsValidationDelivery) {
          return;
        }
        this.currentStep = "lineItems";
      }
      if (currentStep === "lineItems") {
        const PO_NUMBER = this.$refs.loadDetail.getIfPOIsValid();
        const fieldsValidationLineItems =
          await this.$refs.lineItemsContainer.validateLineItemsReference();
        let ftlLimitsValidation = true;
        if (
          this.chosenLoad.mode_id === modes.ftl.modeId ||
          this.chosenLoad.mode_id === modes.reefer.modeId
        ) {
          ftlLimitsValidation = await this.$refs.lineItemsContainer.validateFTLLimits();
        }
        if (!ftlLimitsValidation) {
          this.creatingLoad = false;
          this.notifyWeightLimit();
        }
        if (fieldsValidationLineItems && ftlLimitsValidation && PO_NUMBER) {
          const lineItemsRequests = await this.$refs.lineItemsContainer.updateLoadLineItems();
          const loadRequests = await this.updateStopsendpointconsumption();
          this.openConfirmationModal();
          this.patchInsuranceInfoToLoad();
          this.loadPromisesHandler([lineItemsRequests, loadRequests].flat());
        }
      }
    },
    getStopData(data, mode) {
      if (mode === "pickup") {
        this.stopsPickup = data;
      } else {
        this.stopsDelivery = data;
      }
    },
    reponsiveFlowBack(data) {
      this.currentStep = data;
    },
    async tender() {
      const insuranceRequired = this.parseQueryBoolean(this.$route.query.insurance);
      const data = {
        id: this.$route.params.loadId,
        body: {
          carrier_id: this.$route.params.carrierId,
          insurance_required: insuranceRequired,
        },
      };
      await this.$store.dispatch("load/tender/createTender", data);
    },
    getTransitTime() {
      const param = this.$route.params.carrierId;
      const id = "_id";
      if (param && id) {
        const carrier = this.carriersAndTrucks.carriers.find((element) => element[id] === param);
        this.transitTime = carrier.transitTime ? carrier.transitTime.toString() : "0";
      }
    },
    loadIsHazmat() {
      this.isHazmat = this.chosenLoad.accessorials.some(
        (item) => item.name.toLowerCase().includes("hazmat") && item.name.toLowerCase() !== "non hazmat"
      );
    },
    validateIfThereAreNewData(newInfo, oldInfo) {
      let newInfoValidation = false;
      if (!oldInfo) {
        newInfoValidation = true;
      } else {
        Object.keys(newInfo).forEach((key) => {
          if (newInfo[key] !== oldInfo[key]) {
            newInfoValidation = true;
          }
        });
      }
      return newInfoValidation;
    },
    handleModalClosing() {
      this.$store.commit("triggerAbortController");
    },
    getReferences(data) {
      this.references[data.mode] = { ...data };
      this.updateCollectionInIndexedDB(
        "tenderReferences",
        this.$route.params.loadId,
        this.references
      );
    },
    retrieveInfoFromIndexedDBCollection(references) {
      Object.keys(references).forEach((key) => {
        if (references[key] && key in this.shippingInfo) {
          this.shippingInfo[key].references = references[key].references;
        }
        if (key === "loadInformation") {
          const serverData = this.references.loadInformation;
          const cachedData = references[key];
          this.references[key] = {
            billing_reference: serverData?.billing_reference || cachedData?.billing_reference || "",
            po_number: serverData?.po_number || cachedData?.po_number || "",
            container: serverData?.container || cachedData?.container || "",
          };
        } else {
          this.references[key] = references[key];
        }
      });
    },
    changeLoadingTender(data) {
      this.$data[data.loadingType] = data.value;
    },
    getLoadCarrierSelectedInfo() {
      const carrierId = this.$route.params.carrierId;
      if (this.carriersAndTrucks?.carriers?.length) {
        const found = this.carriersAndTrucks.carriers.find((carrier) => {
          // eslint-disable-next-line no-underscore-dangle
          const id = carrier?._id;
          return id === carrierId;
        });
        if (found) {
          this.selectedCarrier = found;
          return;
        }
      }
      const allCarriers = this.$store.getters["carriers/getCarriers"] || [];
      const found = allCarriers.find((carrier) => {
        // eslint-disable-next-line no-underscore-dangle
        const id = carrier?._id;
        return id === carrierId;
      });
      if (found) {
        this.selectedCarrier = found;
      }
    },
    parseQueryBoolean(value) {
      if (value === true || value === false) return value;
      if (value === "true") return true;
      if (value === "false") return false;
      return Boolean(value);
    },
    async patchInsuranceInfoToLoad() {
      const insuranceRequired = this.parseQueryBoolean(this.$route.query.insurance);
      if (!insuranceRequired) return;
      const fee = Number(this.chosenLoad?.cargocare_insurance_selling_rate_amount);
      const cargocareFee = Number.isFinite(fee) ? fee : 0;
      const cargoValue = this.chosenLoad?.cargo_value_for_insurance;
      const body = {
        cargocare_insurance_selling_rate_amount: cargocareFee,
        ...(cargoValue !== undefined && { cargo_value_for_insurance: cargoValue || null }),
      };
      await this.$store.dispatch("load/updateLoad", {
        id: this.$route.params.loadId,
        body,
      });
      this.$store.commit("load/modifyChosenLoadSpecificData", {
        key: "cargocare_insurance_selling_rate_amount",
        value: cargocareFee,
      });
      if (body.cargo_value_for_insurance !== undefined) {
        this.$store.commit("load/modifyChosenLoadSpecificData", {
          key: "cargo_value_for_insurance",
          value: cargoValue || null,
        });
      }
    },
    analizeCarrierToLimitIntructions() {
      if (!this.selectedCarrier || !this.selectedCarrier.carrier) {
        this.limitIntructionsCharacters = false;
        return;
      }
      if (
        this.selectedCarrier.carrier === "UPS Ground (EasyPost)" ||
        this.selectedCarrier.carrier === "UPS 3DaySelect (EasyPost)"
      ) {
        this.limitIntructionsCharacters = true;
        return;
      }
      this.limitIntructionsCharacters = false;
    },
    notifyWeightLimit() {
      this.swal({
        title: `Weight limit exceeded`,
        text: "Total weight should not exceed the load initial weight.",
        icon: "error",
        dangerMode: true,
      });
    },
    async getCarrierById() {
    // Check if mode is drayage
      const isDrayage = this.chosenLoad?.mode_name?.toLowerCase() === 'drayage';

      if (isDrayage) {
      // Use drayage endpoint
        const response = await this.$store.dispatch("drayage/setInfoCarriers", { load_id: this.$route.params.loadId });
        this.selectedCarrier = {
          carrier: 'Drayage Service',
          ...response
        };
      } else {
      // Use regular carriers endpoint
        const response = await this.$store.dispatch(
          "carriers/getCarrierById",
          this.$route.params.carrierId
        );
        this.selectedCarrier = response;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../assets/scss/components/Modal.scss";
@use "../../../assets/scss/components/StopsResume.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/buttons/_buttons' as *;
@use '@/assets/scss/_extend' as *;

.divider {
  width: 90%;
  margin-top: 10px;
  border-bottom: 1px solid $color-border-container;
}

.loading {
  svg,
  p {
    color: $color-primary-company;
    font-weight: bold;
  }
}
.loading-overlay-tender {
  max-width: 500px;
  svg,
  p {
    color: $color-primary-company;
  }
}
.operation-selector-container {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: auto;

  ::v-deep .rc-select-container {
    background: $color-gray-light;
    cursor: not-allowed;
  }
}
::v-deep .bg-light {
  background-color: $color-gray-light !important;
}
///****Tabs styles****\\\\
::v-deep .card-header {
  background-color: $color-white;
  border-bottom: 0px;
  padding: 12px 9.8px;
}
::v-deep .card-body {
  background: $color-background;
  border: 1px solid $color-border-container;
  border-radius: 0px 10px 10px 10px;
  font-family: $font-family-portal;
  padding: 25px 0;
}
::v-deep .nav-tabs .nav-link {
  background-color: $color-gray-dark;
  color: $color-white;
  font-family: $font-family-portal;
  @include font-small-information;
  font-weight: bold;
  border: 1px solid $color-border-container;
  border-left: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 15px 30px;
  cursor: default;
}
::v-deep .nav-tabs .nav-link.active {
  color: $color-primary-company;
  font-family: $font-family-portal;
  @include font-small-information;
  font-weight: bold;
  background-color: $color-background;
  border: 1px solid $color-border-container;
  padding: 15px 30px;
}
::v-deep .nav-tabs > li {
  &:first-child > a {
    border-top-left-radius: 20px;
  }
  &:last-child > a {
    border-top-right-radius: 20px;
  }
}
// Date and time picker styles
::v-deep .el-input {
  width: 100%;
  border-radius: 20px;
}
::v-deep .el-input__icon {
  line-height: unset;
  color: $color-border-container;
}
::v-deep .el-collapse-item__wrap {
  background: transparent;
}
::v-deep .el-input__inner {
  height: 35px;
  border-radius: 12px;
  border: 1px solid $color-border-container;
  line-height: unset;
  text-align: center;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 0;
}
::v-deep {
  .el-collapse-item__header {
    background-color: $color-gray-light;
    color: $color-primary-company;
    font-size: 0.95rem;
  }
  .el-collapse-item__content {
    background-color: $color-gray-light;
    color: $color-primary-company;
    font-size: 14px;
    padding-bottom: 0;
  }
}
::v-deep .b-table-stacked-lg > tbody > tr {
  @media (max-width: 991.98px) {
    border-radius: 5px;
    box-shadow: 0 1px 12px rgba(0, 0, 0, 0.09), 0 1px 5px rgba(0, 0, 0, 0.09);
    margin: 20px 10px;
    padding: 10px 0px 10px 0px;
    word-wrap: break-word;
  }
}

::v-deep .position-absolute.bg-light.rounded-sm {
  opacity: 0.45 !important;
}
/* Residential Validations Styles*/
.message-error {
  display: flex;
  position: static;
  color: $color-error;
  margin-left: 3px;
  font-size: 0.8rem;
  position: absolute;
  top: 281px;
  left: 65%;
}
</style>
